var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 25 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.257 24.017H5.82l17.267-17.22a3.95 3.95 0 0 0 1.171-2.828 3.936 3.936 0 0 0-1.185-2.82 3.988 3.988 0 0 0-5.607.026L.257 18.442v5.575Zm4.933-1.55H1.82v-3.39L16.01 4.833l3.424 3.425L5.19 22.467ZM20.53 7.162 22 5.697a2.418 2.418 0 0 0 .715-1.728c0-.655-.259-1.264-.722-1.721a2.436 2.436 0 0 0-3.423.013l-1.467 1.473 3.428 3.428Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Edit.d523ec753f7163498904454a20133308.svg";